function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.778 10.311V3.378c0-.636-.52-1.156-1.155-1.156H5.689c-.635 0-1.155.52-1.155 1.156v6.933c0 .636.52 1.156 1.155 1.156h6.934c.635 0 1.155-.52 1.155-1.156zM7.654 8.306l.942 1.26 1.49-1.86a.289.289 0 0 1 .45 0l1.711 2.137c.15.19.017.468-.225.468H6.267a.289.289 0 0 1-.231-.462l1.156-1.543a.293.293 0 0 1 .462 0zm-5.431 4.316v-7.51a.58.58 0 0 1 .577-.579.58.58 0 0 1 .578.578v6.933c0 .318.26.578.578.578h6.933a.58.58 0 0 1 .578.578.58.58 0 0 1-.578.578H3.38c-.636 0-1.156-.52-1.156-1.156z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/image.f7aee32e.svg";
export { SvgComponent as ReactComponent };